export const TABS_DATA = [
    { id: 'ChecklistMaintenanceDetail', label: 'ChecklistMaintenance' },
];
